import { render, staticRenderFns } from "./SpotPricing.vue?vue&type=template&id=644dfb12&scoped=true"
import script from "./SpotPricing.vue?vue&type=script&lang=js"
export * from "./SpotPricing.vue?vue&type=script&lang=js"
import style0 from "./SpotPricing.vue?vue&type=style&index=0&id=644dfb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644dfb12",
  null
  
)

export default component.exports